/**
 * Horizon's desktop regime (base.css ≥990px) locks html/body to 100dvh and
 * scrolls .page-wrapper instead — the viewport itself must never scroll.
 * But the browser treats overflow:clip on the ROOT as hidden, and focusing
 * any element near the fold (a Your Set checkbox via its label, a dialog
 * control, a chat widget) makes it scroll every scrollable ancestor —
 * including the locked viewport. Paint then sits hundreds of px away from
 * .page-wrapper's scrollTop and the page looks like it lost its bottom half
 * (reproduced 2026-08-22: header at -440px after one checkbox click).
 *
 * The guard snaps the viewport back the moment anything scrolls it. Below
 * 990px the lock doesn't exist and the viewport is the real scroller, so
 * the guard stands down there.
 */

const lockRegime = window.matchMedia('(min-width: 990px)');

window.addEventListener(
  'scroll',
  () => {
    if (!lockRegime.matches) return;
    if (!(window.scrollY || window.scrollX)) return;
    if (!document.querySelector('.page-wrapper')) return;
    window.scrollTo(0, 0);
  },
  { passive: true }
);
